import { render, staticRenderFns } from "./numbers-stats-general-table-filter.vue?vue&type=template&id=f980466e&scoped=true&"
import script from "./numbers-stats-general-table-filter.vue?vue&type=script&lang=js&"
export * from "./numbers-stats-general-table-filter.vue?vue&type=script&lang=js&"
import style0 from "./numbers-stats-general-table-filter.vue?vue&type=style&index=0&id=f980466e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f980466e",
  null
  
)

export default component.exports